import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";
import BDServiceCard from "@/pages/services/business-development/BDServiceCard";

const COMPANY_NAME = "NetBasis International";

const bdTitle = "Business Development";
const bdHeroOverlay = "Immer Ihr Geschäft im Blick!";
const bdHeroAlt = "Geschäftsmann plant Geschäftsstrategien und Vertriebswege für den ITK-Markteintritt im DACH-Markt.";
const bdH1 = "Ihr strategischer und operativer Partner für den erfolgreichen Geschäftsaufbau in der DACH-Region. Wir entwickeln praxisnahe Marktstrategien für ausländische ITK-Unternehmen und setzen diese gemeinsam mit Ihnen erfolgreich vor Ort um.";
const bdIntro = "NetBasis International unterstützt die gesamten Geschäftsvorhaben seiner Herstellerpartner – sei es bei der Einführung bereits bestehender Produkte, Lösungen und Services in für sie neue internationale Märkte oder beim Aufbau neuer Geschäftsfelder oder Marktchancen. Wir generieren und entwickeln praktische sowie effektive Geschäftsstrategien, erstellen und liefern die erforderlichen Umsetzungspläne, unterstützen unsere Partner während der Umsetzungsphase und auf Wunsch auch darüber hinaus.";
const benefitsTitle = "Wie Sie von unserer Expertise im Bereich __Business Development__ profitieren:";
const readMore = "Mehr erfahren";
const bottomClaim = "NetBasis International – drive to excellence with excellent drivers !";

const services = [
  {
    name: "Geschäftspräsenz",
    image: "https://net-basis.net/Bilder/duesseldorf-media-harbor-rhine-tower-business-location.webp",
    description: "Lokale Adresse & Erreichbarkeit: Wir bieten Ihrem ITK-Unternehmen eine feste Präsenz in Düsseldorf und führen Ihr Geschäft vor Ort – kosteneffizient und rechtssicher.",
    to: "/de/services/business-development/geschaeftspraesenz",
  },
  {
    name: "Full-Service-Angebot",
    image: "https://net-basis.net/Bilder/ict-full-service-business-development-management.webp",
    description: "Ihr verlängerter Arm im DACH-Raum: Wir übernehmen Ihr gesamtes lokales Geschäft von A bis Z. So bleibt Ihr Kopf komplett frei für Ihren Heimatmarkt.",
    to: "/de/services/business-development/full-service-angebot",
  },
  {
    name: "Consulting",
    image: "https://net-basis.net/Bilder/ict-market-entry-business-strategy-consulting.webp",
    description: "Strategie mit Weitblick: Wir bewerten Ihre Marktpotenziale im DACH-Raum und begleiten Sie mit maßgeschneiderter B2B-Beratung von der Analyse bis zum Erfolg.",
    to: "/de/services/business-development/consulting",
  },
  {
    name: "Produktmanagement",
    image: "https://net-basis.net/Bilder/ict-product-management-market-adaptation-modular-development.webp",
    description: "Erfolg im DACH-Markt: Wir passen Ihre ITK-Produkte präzise an lokale Standards, Gesetze und Märkte an.",
    to: "/de/services/business-development/produktmanagement",
  },
  {
    name: "Projektmanagement",
    image: "https://net-basis.net/Bilder/project-management-planning-control-dach-market-entry.webp",
    description: "Effizientes Controlling: Wir steuern Ihre komplexen Vorhaben in der DACH-Region risikobewusst, termintreu und budgetkonform.",
    to: "/de/services/business-development/projektmanagement",
  },
  {
    name: "Marktanalysen",
    image: "https://net-basis.net/Bilder/market-analysis-business-intelligence-dach-market-entry.webp",
    description: "Faktenbasierte Sicherheit: Wir liefern Ihnen präzise Daten zu Marktgrößen, Trends und der lokalen Konkurrenz.",
    to: "/de/services/business-development/marktanalysen",
  },
  {
    name: "Markteintritt",
    image: "https://net-basis.net/Bilder/dach-market-entry-strategy-target-market-positioning.webp",
    description: "Der optimale Start: Wir konzipieren Ihre Eintrittsoptionen und planen Ihren nachhaltigen Erfolg im DACH-Markt.",
    to: "/de/services/business-development/markteintritt",
  },
  {
    name: "Import-Management",
    image: "https://net-basis.net/Bilder/import-management-customs-clearance-dach-distribution.webp",
    description: "Ihre kaufmännische Importabteilung: Wir steuern Ihre DACH-Logistik ganzheitlich – von der rechtssicheren Zollabwicklung bis zur termingerechten Lieferung.",
    to: "/de/services/business-development/importmanagement",
  },
  {
    name: "Internationaler Handel",
    image: "https://net-basis.net/Bilder/international-trade-dach-local-expertise.webp",
    description: "Sichere Handelsgeschäfte: Wir regeln Ihre Preisstrukturen, Verträge und Handelslizenzen im DACH-Raum – für einen rechtssicheren und profitablen Marktstart.",
    to: "/de/services/business-development/internationaler-handel",
  },
  {
    name: "Technischer Support",
    image: "https://net-basis.net/Bilder/technical-support-dach-customer-service.webp",
    description: "Schnelle technische Hilfe: Wir bieten qualifizierten ITK-Support, zuverlässige Fernwartung und Vor-Ort-Unterstützung direkt für Ihre Kunden im DACH-Raum.",
    to: "/de/services/business-development/technischer-support",
  },
];

const benefits = [
  "Identifizierung und Erschließung optimaler Vertriebswege sowie Partnernetzwerke",
  "Konzeption zielgerichteter Marketing- und Werbestrategien",
  "Fundierte Empfehlungen für notwendige Produktmodifikationen oder Marktanpassungen",
  "Initiierung zukunftsfähiger Produktentwicklungsmöglichkeiten",
  "Strukturierte Vorbereitung des operativen Geschäftsbetriebes und der lokalen Logistik",
  "Präzise Planung bei der Realisierung von vereinbarten Geschäftsstrategien",
  "Analyse und Bewertung potenzieller Chancen für Technologietransfers, Lizenzkooperationen, Joint Ventures oder Fusionen",
];

export default function BusinessDevelopmentDePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Business Development | NetBasis International"
        description="Strategische Markterschließung und operative Verkaufsunterstützung für Ihren nachhaltigen Erfolg im deutschsprachigen Raum."
        ogUrl="https://net-basis.net/de/services/business-development"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src="https://net-basis.net/Bilder/ict-business-development-strategy-dach-market-entry.webp"
                alt={bdHeroAlt}
                title={bdTitle}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
              <div className="absolute inset-0 z-20 flex items-start justify-end md:justify-start pl-10 md:pl-[30%] lg:pl-[15%] pr-6 md:pr-10 pointer-events-none">
                <p
                  className="w-full text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-right mt-2 md:mt-8 lg:mt-12 max-w-[85%] md:max-w-none animate-[bdTextSlide_12s_ease-in-out_infinite]"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  {bdHeroOverlay}
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {bdTitle}
            </h2>
            <h1 className="text-foreground-950 font-semibold text-sm md:text-base leading-relaxed mb-4">
              {bdH1}
            </h1>
            <p className="text-foreground-950 leading-relaxed text-sm md:text-base">
              <strong className="text-primary-600">{COMPANY_NAME}</strong>{" "}
              {bdIntro.replace(COMPANY_NAME, "").trim()}
            </p>
          </div>
        </section>

        <section className="py-5 md:py-7 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col gap-3 md:gap-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                {services.slice(0, 3).map((svc, idx) => (
                  <BDServiceCard key={idx} name={svc.name} image={svc.image} description={svc.description} to={svc.to} readMore={readMore} />
                ))}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
                {services.slice(3, 7).map((svc, idx) => (
                  <BDServiceCard key={idx} name={svc.name} image={svc.image} description={svc.description} to={svc.to} readMore={readMore} />
                ))}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
                {services.slice(7, 10).map((svc, idx) => (
                  <BDServiceCard key={idx} name={svc.name} image={svc.image} description={svc.description} to={svc.to} readMore={readMore} />
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {benefitsTitle.split('__').map((part, i) =>
                i % 2 === 1 ? <em key={i}>{part}</em> : part
              )}
            </h2>
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}